import {AdminAxios} from "../../common/Axios";

const REGION_MANAGE_URL = "/adver/region/manage";

const assertSuccess = response => {
  if (response?.statusCode !== 200) {
    throw new Error(response?.message || "지역 정보 처리에 실패했습니다.");
  }
  return response?.data;
};

export async function retrieveManagedRegions(level, parentCode = "") {
  const query = new URLSearchParams({level});
  if (parentCode) query.set("parentCode", parentCode);
  const response = await AdminAxios("GET", `${REGION_MANAGE_URL}?${query.toString()}`);
  const data = assertSuccess(response);
  return Array.isArray(data) ? data : [];
}

export async function updateManagedRegion(code, region) {
  const response = await AdminAxios(
      "PUT",
      `${REGION_MANAGE_URL}/${encodeURIComponent(code)}`,
      {
        name: region.name.trim(),
        parentCode: region.parentCode || null,
        sortOrder: Number(region.sortOrder),
        activeYn: region.activeYn
      }
  );
  assertSuccess(response);
  return true;
}

export async function createManagedRegion(region) {
  const response = await AdminAxios(
      "POST",
      REGION_MANAGE_URL,
      {
        code: region.code.trim(),
        name: region.name.trim(),
        level: "REGION",
        parentCode: region.parentCode,
        sortOrder: Number(region.sortOrder)
      }
  );
  assertSuccess(response);
  return true;
}

export async function deleteManagedRegion(code) {
  const response = await AdminAxios(
      "DELETE",
      `${REGION_MANAGE_URL}/${encodeURIComponent(code)}`
  );
  assertSuccess(response);
  return true;
}
